import React, { FC, Fragment, useMemo } from 'react'
import { observer } from 'mobx-react'
import ProductItem from '../../ProductItem'
import { themeMobx, decorationMobx, buyTogetherMobx, recommendMobx } from '@mobxStore'
import { menuMobx, cartMobx } from 'restaurant'
import './index.scss'

// interface
interface IProps {
  category: IMenuCategory;
  type: 'classic' | 'list';
  advertMap?: { [key: string]: any[] };
}

const CategoryItem: FC<IProps> = ({ category, type, advertMap }) => {
  const { productNoToCntMap } = cartMobx.cartResult
  const isBuyTogether = !!Config.buyTogetherId
  const { mealDecorates } = decorationMobx
  const { no, name, desc, products } = category
  const isColumn = useMemo(() => {
    return desc && (name.zhLength() > 6 || (name.zhLength() < 6 && desc.zhLength() > 12))
  }, [category])
  return (
    <div
      className='category-list category-item'
      id={`category-item-${no}`}
      data-id={`category-${no}`}
    >
      <div className={`category-title${isColumn ? ' column' : ''}`}>
        <div className='title' style={{ fontSize: `${mealDecorates?.fontSetting?.menuCategory?.fontSize || 16}px`, fontWeight: mealDecorates?.fontSetting?.menuCategory?.fontWeight ? 700 : 500 }}>{name}</div>
        {desc && <div className='sub-title'>{desc}</div>}
      </div>
      {
        products.map((product) => {
          const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : productNoToCntMap?.[product.no] || 0
          return (
            <Fragment key={product.no}>
              <ProductItem
                backgroundMode={themeMobx.data.backgroundMode}
                type={type}
                product={product}
                count={count}
                mealDecorates={decorationMobx.mealDecorates}
              />
            </Fragment>
          )
        })
      }
    </div>
  )
}

export default observer(CategoryItem)
